import React, { useEffect, useState } from 'react';

/**
 * Тост кабинета. Раньше он был скопирован в каждую форму со своим
 * набором инлайновых стилей — теперь один компонент и один класс.
 */

export type ToastTone = 'success' | 'error';

export interface ToastMessage {
  message: string;
  tone: ToastTone;
}

const TOAST_TIMEOUT_MS = 3500;

/** Сообщение и функция показа: тост сам гаснет через 3,5 с. */
export function useToast(): [ToastMessage | null, (next: ToastMessage | null) => void] {
  const [toast, setToast] = useState<ToastMessage | null>(null);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), TOAST_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [toast]);

  return [toast, setToast];
}

export function Toast({ toast }: { toast: ToastMessage | null }) {
  if (!toast) return null;

  return (
    <div className={`qp-toast qp-toast--${toast.tone}`} role="status" aria-live="polite">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
        {toast.tone === 'success' ? (
          <path d="M5 12l5 5L20 7" strokeWidth="2.5" strokeLinejoin="round" />
        ) : (
          <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5M12 16.5h.01" />
          </>
        )}
      </svg>
      {toast.message}
    </div>
  );
}
